export default __webpack_public_path__ + "static/media/RTR1604V_LateralIzq.458f5382.webp";